import clsx from 'clsx';

const STATUS_COLORS = {
    draft: { bg: 'rgba(100,116,139,0.15)', color: '#94a3b8', label: 'Draft' },
    review: { bg: 'rgba(240,173,78,0.15)', color: '#f0ad4e', label: 'Review' },
    in_review: { bg: 'rgba(240,173,78,0.15)', color: '#f0ad4e', label: 'Review' },
    published: { bg: 'rgba(100,255,218,0.15)', color: '#64ffda', label: 'Published' },
    archived: { bg: 'rgba(71,85,105,0.15)', color: '#64748b', label: 'Archived' },
};

export default function StatusBadge({ status }) {
    const s = STATUS_COLORS[status] || STATUS_COLORS.draft;

    return (
        <span
            className={clsx('badge', `badge-${status}`)}
            style={{
                background: s.bg,
                color: s.color,
                padding: '0.15rem 0.6rem',
                borderRadius: '9999px',
                fontSize: '0.7rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'inline-flex',
                alignItems: 'center',
            }}
        >
            {s.label}
        </span>
    );
}